// Func = limiting Scope for this file
var lastScrollTop = 0;

//datepicker booking
var opened = 0;
var originstart = $('#arriveInput').attr('value');
var originend = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0;

var ulFilter = 0;

//resize sizes
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//home header
if(document.getElementsByClassName('img-slide').length > 0){
	if(document.getElementById('home')){
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	} 
}
resizeWindow();


(function(){

	//Booking events
	
	document.getElementById('bookingClose').addEventListener('click', function(e){
		e.preventDefault();
		if(document.getElementById('home') && lastScrollTop < 80){
			document.getElementById('bookingBlock').classList.add('home');
		}
		document.getElementById('bookingBlock').classList.remove('opened');
	});
	document.getElementsByClassName('js-booking-cta')[0].addEventListener('click', function(e){
		e.preventDefault();
		document.getElementById('bookingBlock').classList.remove('home');
		document.getElementById('bookingBlock').classList.add('opened');
	});
	document.getElementsByClassName('js-fake-input')[0].addEventListener('click', function(e){
		e.preventDefault();
		if(document.getElementById('bookingBlock').classList.contains('home')){
			$('#calendarContainer').fadeIn();
		}
	});
	
	//if there is a #
	let pageURL = window.location.href ;
	if(pageURL.indexOf('#') > -1){
        let targetL = pageURL.split('#')[1];
        animateTo(targetL);
	}
	
	//check if there is a link with 
	if(document.getElementsByClassName('js-linkto').length > 0){
		let allLinkTo = document.getElementsByClassName('js-linkto');
		let allLinkToLength = allLinkTo.length;
		for(let i = 0; i < allLinkToLength; i++){
			allLinkTo[i].addEventListener('click', function(e){
				e.preventDefault();
				let currentLink = this.getAttribute('href').split('#');
				animateTo(currentLink[1]);
			});
		}
	}

	

	//home location functionality
	if(document.getElementsByClassName('js-map').length > 0){
		let allLocations = document.getElementsByClassName('hour');
		let allLocationsLength = allLocations.length;
		let allLocationInfo = document.getElementsByClassName('js-hour-item');
		//auto rotation
		let mapInterval = setInterval(myMap, 4000);

		for(let i = 0; i < allLocationsLength; i++){
			allLocations[i].addEventListener('click', function(e){
				e.preventDefault();
				clearTimeout(mapInterval);
				let currentTarget = this.getAttribute('href');
				for(let j = 0; j < allLocationsLength; j++){
					allLocationInfo[j].classList.remove('active');
					allLocations[j].classList.remove('active');
				}
				this.classList.add('active');
				allLocationInfo[i].classList.add('active');
				mapInterval = setInterval(myMap, 4000);
			});
		}

		
	}
	
	$(document).ready(function () {
		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}

		$('#datesCalendar').datepicker({
			changeMonth:false,
			numberOfMonths: 1,
			dateFormat:'mm-dd-yy',
			beforeShowDay: function (clickeddate) {

				$.datepicker._defaults.dateFormat = 'mm-dd-yy';
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, originstart);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, originend);
				if (clickeddate.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (clickeddate.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (clickeddate.getTime() > startDate.getTime() && clickeddate.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (clickeddate) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, originstart);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, originend);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, clickeddate);

				if (opened == 0) {
					opened = 1;
					originstart = clickeddate;
					originend = clickeddate;
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						originend = originstart;
						originstart = clickeddate;
					} else {
						originend = clickeddate;
					}
					if($('#bookingBlock').hasClass('home')){
						$('#calendarContainer').fadeOut();
					}
					
				}
				

				$('#arriveInput').attr('value', originstart);
				$('#departureInput').attr('value', originend);
				setupDate(originstart,originend)
			
			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});

		let specifiedElement = document.getElementById('bookingBlock');
		document.addEventListener('click', function(event){
			let isClickInside = specifiedElement.contains(event.target);
			if (!isClickInside) {
				if($('#bookingBlock').hasClass('home')){
					$('#calendarContainer').fadeOut();
				}
			
			}
		});
		

		
	});
	window.onload = function() {

		if(document.getElementById('attractions') || document.getElementsByClassName('sitemap').length > 0 || document.getElementById('gallery')){
				document.getElementById('header').classList.add('down');
				document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src', site_url + 'assets/svg/logo.svg');
			
		} else {
			scrollW();
			scrollDownAction(20, 'scroll');
			window.addEventListener('scroll', function(){
				scrollW();
			});
		}

		if(document.getElementsByClassName('lodging-filter').length > 0){
			ulFilter = document.getElementsByClassName('lodging-block')[0].offsetTop;
			console.log(ulFilter)
		}

		resizeWindow();
		window.addEventListener('resize', function(){
			resizeWindow();
		});
	};
}());
function setupDate(startt,endt){
	let newstart = startt.split('-');
	let newend = endt.split('-');
	$('.js-fake-input').attr('value', newstart[0] + '-' + newstart[1] + '-' + newstart[2] + ' / ' + newend[0] + '-' + newend[1] + '-' + newend[2]);
}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(!document.getElementById('attractions') || document.getElementsByClassName('sitemap').length < 1 || !document.getElementById('gallery')){
		if(st > 30){
			if (st > lastScrollTop){
				// downscroll code
				if(!document.getElementById('header').classList.contains('down')){
					document.getElementById('header').classList.add('down');
					document.getElementById('header').classList.remove('up');
				}
			} else {
				// upscroll code
				if(!document.getElementById('header').classList.contains('up')){
					document.getElementById('header').classList.add('up');
					document.getElementById('header').classList.remove('down');
				}
			}
			if(document.getElementById('home')){
				
				if(document.getElementById('bookingBlock').classList.contains('home')){
					document.getElementById('bookingBlock').classList.remove('opened')
					document.getElementById('bookingBlock').classList.remove('home');
				}
			}
			//check if there is a submenu to work and stick
			if(document.getElementsByClassName('sub-menu').length > 2){
				
				if(st > 490){
					if(!document.getElementById('content').getElementsByClassName('sub-menu')[0].classList.contains('fixed-top')){
						document.getElementById('content').getElementsByClassName('sub-menu')[0].classList.add('fixed-top')
					}
				} else {
					if(document.getElementById('content').getElementsByClassName('sub-menu')[0].classList.contains('fixed-top')){
						document.getElementById('content').getElementsByClassName('sub-menu')[0].classList.remove('fixed-top')
					}
				}
			}
			// fixed filter for accommodations page.
			if(document.getElementsByClassName('lodging-filter').length > 0){
				
				if(st > ulFilter){
					if(!document.getElementsByClassName('lodging-filter')[0].classList.contains('fixed-top')){
						document.getElementsByClassName('lodging-filter')[0].classList.add('fixed-top')
						
					}
				} else {
					if(document.getElementsByClassName('lodging-filter')[0].classList.contains('fixed-top')){
						document.getElementsByClassName('lodging-filter')[0].classList.remove('fixed-top')
					}
				}
			}
				
		} else {
			if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.remove('up');
				document.getElementById('header').classList.remove('down');
			}
			if(document.getElementById('home')){
				if(!document.getElementById('bookingBlock').classList.contains('home')){
					document.getElementById('bookingBlock').classList.remove('opened');
					document.getElementById('bookingBlock').classList.add('home');
				}
			}
		}
	} 
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('img-slide').length > 0){
		if(document.getElementById('home')){
			let headerImages = document.getElementsByClassName('img-slide');
			let headerImagesLength = headerImages.length;
			for(let i = 0; i < headerImagesLength; i++){
				headerImages[i].style.height = (windowHeight + 10) + 'px';
			}
		} 
	}
}
function myMap() {
	let allLocations = document.getElementsByClassName('hour');
	let allLocationsLength = allLocations.length;
	let allLocationInfo = document.getElementsByClassName('js-hour-item');
	let activeState = 0;

	for(let i = 0; i < allLocationsLength; i++){
		if(allLocations[i].classList.contains('active')){
			if(i == (allLocationsLength - 1)){
				activeState = 0;
			} else {
				activeState = i + 1;	
			}
			allLocations[i].classList.remove('active');
			allLocationInfo[i].classList.remove('active');
		}
	}
	allLocations[activeState].classList.add('active');
	allLocationInfo[activeState].classList.add('active');
}